
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCoachResourcesExercisesListIndex} from "@/models/app/coach/resources/exercises/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachResourcesExercisesListFormLookupIndexVue from "@/views/app/coach/resources/exercises/list/form/lookup.vue";
import AppCoachResourcesExercisesListFormCreateIndexVue from "@/views/app/coach/resources/exercises/list/form/create.vue";
import AppCoachResourcesExercisesListFormUpdateIndexVue from "@/views/app/coach/resources/exercises/list/form/update.vue";
import AppCoachResourcesExercisesListFormRemoveIndexVue from "@/views/app/coach/resources/exercises/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppCoachResourcesExercisesListFormLookupIndexVue,
    AppCoachResourcesExercisesListFormCreateIndexVue,
    AppCoachResourcesExercisesListFormUpdateIndexVue,
    AppCoachResourcesExercisesListFormRemoveIndexVue,
  },
})
export default class AppCoachResourcesExercisesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  exercises: Array<AppCoachResourcesExercisesListIndex> = [];

  async getExercises(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/exercises`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.exercises = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getExercises();
  }
}
